import {
  BarChart3, LineChart, Wallet, Shield, Rocket, Landmark, Building2,
  PiggyBank, Briefcase, ScrollText, Home, Coins, TrendingDown, Boxes, Package,
} from "lucide-react";

export const PRODUCT_ICONS = {
  BarChart3, LineChart, Wallet, Shield, Rocket, Landmark, Building2,
  PiggyBank, Briefcase, ScrollText, Home, Coins, TrendingDown, Boxes,
};

export function productIcon(name) {
  return PRODUCT_ICONS[name] || Package;
}

// Build a short summary line for a product's holdings
export function summarizeProduct(product, holdings, portfolioPer) {
  const per = portfolioPer?.find((p) => p.key === product.key);
  const count = holdings.length;
  if (count === 0) return null;
  return { count, invested: per?.invested || 0, current: per?.current || 0 };
}
